import { Card, Select, Space, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import EditService from '@/components/UI/EditService';
import type { UserGroup } from '@/types/database/userGroup';
import type { RootState } from '@/redux/store';
import useService from '@/lib/hooks/useService';

import AuthSetting from '../AuthSetting';
import { getColumns, getServiceOptions, getTableData } from '../helper';
import styles from './index.module.scss';

const { Title, Text } = Typography;

const AuthList = () => {
  const user = useSelector((state: RootState) => state.user);

  const [userGroups, updateUserGroups] = useService<UserGroup>({
    collectionName: 'userGroup',
  });

  const [userAuth, setUserAuth] = useState('');
  const [selectedService, setSelectedService] = useState('');

  useEffect(() => {
    if (user) {
      setUserAuth(user.auth.user.auth);
    }
  }, [user]);

  const columns = getColumns({ auth: userAuth, userGroups, updateUserGroups });
  const dataSource = getTableData(userGroups, selectedService);
  const serviceOptions = getServiceOptions(userGroups);

  return (
    <Space direction="vertical" className={styles.widthFull}>
      <Space>
        <AuthSetting type="add" updateUserGroups={updateUserGroups} />
        <EditService />
      </Space>
      <Space>
        <Text>服務:</Text>
        <Select
          allowClear
          placeholder="請選擇服務"
          className={styles.selectWidth}
          options={serviceOptions}
          onChange={(value) => setSelectedService(value)}
        />
      </Space>
      <Card>
        <Title level={5}>服務項目</Title>
        <Table
          bordered
          rowKey="_id"
          columns={columns}
          dataSource={dataSource}
          scroll={{ x: 'max-content' }}
        />
      </Card>
    </Space>
  );
};

export default AuthList;
